import { HttpErrorResponse } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { APIURL } from "app/Shared/Constant/API_Urls";
import { SharedHttpClientService } from "app/Shared/Services/shared-http-client.service";
import { UserService } from "app/Shared/Services/user.service";
import { environment } from "environments/environment";
import { BrokerMapping } from "./broker-mapping.model";
import { map } from "rxjs";
import { GridService } from "app/Shared/Services/grid.service";

@Injectable()
export class BrokerMappingService {
    isEdit: boolean = false;
    isView: boolean = false;
    isAdd: boolean = false;
    defaultData: any;
    dataset: any = [];
    DefaultFilterArray: any = [];
    isLoadingResults = false;
    rowcount!: number;
    totalRecords: any = 0;
    startLimit: any = 0;
    endLimit!: number;
    affiliateFlag = [
        { "label": "Y", "value": "Y", "description": "True" },
        { "label": "N", "value": "N", "description": "False" }]
    editRow!: BrokerMapping | any;
    addRow: BrokerMapping|any = new BrokerMapping();
    constructor(
        private sharedHttpClientService: SharedHttpClientService,
        private userService: UserService,
      private gridService: GridService,) {
    }

    defaultFiltter() {
        this.DefaultFilterArray = [
          { 'isdefault': 'true', 'label': 'CustomerID', 'columnname': 'customerID', 'filterby': 'IS', 'values': '', 'time': '', 'datatype': 'String', 'disabled': 'false', 'dropdown': '', 'dropdownvalue': '' },
          { 'isdefault': 'true', 'label': 'ReceivedFromMPID', 'columnname': 'receivedFromMPID', 'filterby': 'IS', 'values': '', 'time': '', 'datatype': 'String', 'disabled': 'false', 'dropdown': '', 'dropdownvalue': '' },
          {
            'isdefault': 'true', 'label': 'AffiliateFlag', 'columnname': 'AffiliateFlag', 'filterby': 'IS', 'values': '', 'time': '', 'datatype': 'String', 'disabled': 'false', 'dropdown': 'YES', 'dropdowntype': 'singleSelect', 'dropdownvalue': [
              { 'label': 'Y', 'value': 'Y', 'description': 'True' },
              { 'label': 'N', 'value': 'N', 'description': 'False' }]
          },
        ];
      }

      getDefaultFilters(){
        return this.DefaultFilterArray;
      }

    reloadData() {
        let payload = {
            "mpid": this.userService.getActiveMPID(),
            "data": this.DefaultFilterArray,
            "startLimit": this.startLimit,
            "endLimit": this.rowcount
          }
        return this.sharedHttpClientService.post(
            environment.apiUrl + "API/" + this.userService.getActiveMPID() + "/" + APIURL.CAT_BrokerMapping_List, payload)
            .pipe(map((response: Response) => {
                return response;
              })).subscribe({
                next: (data: any) => {
                  this.isLoadingResults = false;
                  let response: any = data;
                  this.dataset = response.data;
                  this.defaultData = this.dataset;
                  this.totalRecords = response.totalCount;
                  this.totalRecords = this.gridService.handleNoRecordsPageNumber(this.totalRecords);
                },        
                error: (err: HttpErrorResponse) => {
                  this.isLoadingResults = false;
                }
              });  
    }
    
    getData(payload:any) {
        return this.sharedHttpClientService.post(
            environment.apiUrl + "API/" + this.userService.getActiveMPID() + "/" + APIURL.CAT_BrokerMapping_List, payload);
    }
    getAdd(payload:any) {
        return this.sharedHttpClientService.post(
            environment.apiUrl + "API/" + this.userService.getActiveMPID() + "/" + APIURL.CAT_BrokerMapping_Add, payload);
    }
    getEdit(payload:any) {
        return this.sharedHttpClientService.post(
            environment.apiUrl + "API/" + this.userService.getActiveMPID() + "/" + APIURL.CAT_BrokerMapping_Edit, payload);
    }

    getDelete(payload:any) {
        return this.sharedHttpClientService.post(
            environment.apiUrl + "API/" + this.userService.getActiveMPID() + "/" + APIURL.CAT_BrokerMapping_Delete, payload);
    }

}